<template>
  <div class="Download">
    <section-header ja="プリダウンロード">
      <img src="@/assets/Png/title/download.png">
    </section-header>
    <p-text-field
      placeholder="シールIDを入力してね！"
      v-model="sheetId"
      @input="sheetIdValidate">
    </p-text-field>
    <normal-btn @click="onSearch" :disabled="!searchActive">プリGet!</normal-btn>

    <div class="description">ダウンロードできたプリクラは「アルバム」に追加されます。</div>
    <normal-btn @click="onAlbum">アルバムを見る</normal-btn>

    <section>
      <section-header heading="2" ja="ダウンロードできるプリクラ"/>
      <template v-if="splittedSheets.length === 0">
        <text-box title="新しいプリクラは届いてないよ！">
          セガのプリ機で会員証をかざしてプレイするか印刷したシールのIDを入力してね
        </text-box>
      </template>
      <template v-if="membershipGrade > 0 && splittedSheets.length > 0">
        <div v-if=" membershipGrade === 1" class="description">まだアルバムに保存していないプリクラがあるシールです。有料会員になると全てのプリクラを保存できます。</div>
        <!-- 10枚ずつ追加表示 -->
        <div v-for="(sheets, i) in splittedSheets" :key="i">
          <template v-if="i < moreCount">
            <puri-sheet
            v-for="s in sheets"
            :key="s.id"
            :arcade-name=s.arcadeName
            :create-date=s.createDate
            :limit-date=s.limitDate
            :puri-list=s.puriList
            :arcade-logo-img=s.arcadeLogoImg
            :membership-grade=membershipGrade
            @click="onMemberBenefits" />
          </template>
        </div>
        <!-- 次の10枚を表示 -->
        <normal-btn v-if="moreCount < splittedAllSheets.length" @click="plusMoreCount">もっと見る</normal-btn>
      </template>
    </section>

    <v-dialog v-model="hasTappedSheet" max-width="345px">
      <div class="dialog" v-if="tappedSheet != null">
      <button @click="hasTappedSheet = false" class="closeBtn"></button>
        <div class="dialogText">
          <div>{{ tappedSheet.title }}</div>
          <div>{{ tappedSheet.text }}</div>
        </div>
        <normal-btn @click="hasTappedSheet = false">もどる</normal-btn>
        <normal-btn @click="onDialogOK">有料会員登録へ</normal-btn>
      </div>
    </v-dialog>

  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader.vue'
import PuriSheet from '../components/PuriSheet'
import Protobuf from '../mixins/protobuf'
import Screen from '../mixins/screen'
import {daysLeft, splitArray} from "../assets/js/util";
import PTextField from '../components/PTextField'
import NormalBtn from '@/components/NormalBtn.vue'
import TextBox from '@/components/TextBox.vue'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
const ROW_MAX = 10

export default {
  name: "Download",
  components: { SectionHeader, PuriSheet, PTextField, NormalBtn, TextBox },
  mixins: [Protobuf, Screen, TextBox],
  data() {
    return {
      sheetId: '',
      sheets: [],
      page: 0,
      hasTappedSheet: false,
      tappedSheet: null,
      logoList: null,
      membershipGrade: -1,
      result: null,           // 全てのシール情報を配列で格納
      splittedAllSheets: [],  // 全てのシールを10枚で1組に区切って格納
      moreCount: 0,           // シールを10枚ずつ表示するのに使用
      splittedSheets: [],     // 表示するシールのみ格納
    }
  },
  computed: {
    searchActive() {
      return this.sheetId.length === 15
    }
  },
  methods: {
    onSearch() {
      this.$store.state.targetPuriId = this.sheetId;
      const sheetId = this.sheetId
      if (sheetId === "") return
      if (isNaN(sheetId)) {
        this.$_error('Error', { title: 'ダウンロードに失敗しました', statusCode: 423 })
        return
      }else if (sheetId.length !== 15) {
        this.$_error('Error', { title: 'ダウンロードに失敗しました', statusCode: 422 })
      } else {
        this.downloadSheet(sheetId)
      }
    },
    onAlbum() {
      this.$router.push('/album')
    },
    downloadSheet(sheetId) {
      const cmdNo = pb.SheetAddReq.CommandNo.COMMAND_NO
      const message = pb.SheetAddReq.create({
        id: sheetId,
        reserve: false,
      })
      const encoded = pb.SheetAddReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          switch (decoded.status) {
            case pb.SheetAddResp.Status.ALREADY_EXISTS:
              this.$_error('Error', { title: 'プリダウンロード', statusCode: 426 })
              break
            case pb.SheetAddResp.Status.ACCOUNT_MAX:
              this.$_error('Error', { title: 'プリダウンロード', statusCode: 425 })
              break
            case pb.SheetAddResp.Status.EXPIRED:
              this.$_error('Error', { title: 'プリダウンロード', statusCode: 424 })
              break
            case pb.SheetAddResp.Status.SUCCESS:
              // sheetIdをNumber型に変換
              this.$router.push({ name: 'dlfinish',
                params: {
                  id: Number(sheetId),
                  limit: decoded.limitDate,
                  arcade: decoded.arcadeName,
                  create: decoded.createDate,
                }
              })
              break
            default:
              this.$_error('Error', { title: 'プリダウンロード', statusCode: 420 })
              break
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'プリダウンロード', statusCode: 100 })
        })
    },
    onSheet(id) {
      if (!this.$store.getters.isFreeMembership) {
        return
      }
      const sheet = this.sheets.find(s => s.id === id)
      if (!sheet) {
        return
      }
      this.tappedSheet = {
        title: 'ダウンロード期限は撮影から' + daysLeft(sheet.limitDate) + '日間です\n',
        text: 'まだアルバムへ保存していない画像があります。\nダウンロード期限を過ぎるとアルバムへの保存が\nできなくなります。\n有料会員登録を行うとすべての画像を\nアルバムへダウンロードできます。\n'
      }
      this.hasTappedSheet = true
    },
    onDialogOK() {
      this.$router.push('/memberBenefits')
    },
    getLogoList() {
      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
      const message = pb.KumaMasterSettingReq.create()
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.logoList = decoded.masterArcadeList
        })
    },
    async updatePages() {
      this.getLogoList()
      this.sheets = []
      const cmdNo = pb.SheetListReq.CommandNo.COMMAND_NO
      const message = pb.SheetListReq.create()
      const encoded = pb.SheetListReq.encode(message).finish()
      const result = await this.post(cmdNo, encoded)
      this.result = result.sheetList

      if (this.result === undefined || this.result === undefined) {
        this.$_error('Error', { title: 'プリダウンロード', statusCode: 100 })
        return
      }

      this.result.sort((a, b) => a.limitDate > b.limitDate ? 1 : -1)
      this.splittedAllSheets = splitArray(this.result, ROW_MAX)

      // moreCountのwatch起動
      if(this.splittedAllSheets.length > 0) this.moreCount = 1
    },
    sheetIdValidate() {
      this.sheetId = this.sheetId.replace(/\D/g, '')
    },
    onMemberBenefits() {
      this.$router.push('/MemberBenefits')
    },
    checkMemberShip(){
      const cmdNo = pb.PlayerInfoReq.CommandNo.COMMAND_NO
      const message = pb.PlayerInfoReq.create()
      const encoded = pb.PlayerInfoReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.membershipGrade = decoded.membershipGrade
          // 会員情報取得後にプリ情報取得へ
          this.updatePages()
      })
    },
    // シールを10枚ずつ表示させるための
    plusMoreCount(){
      this.moreCount++
    },
    // 一気にダウンロードするシールが10枚を超えると通信エラー起きるので、分割して表示
    splitSheetLists(){
      const arr = this.sheets
      this.splittedSheets = splitArray(arr, ROW_MAX)
    },
    // moreCountに従って10枚以内でシール情報を取得、格納
    async getPuriContents(newValue, oldValue){
      const requests = []
      this.result.forEach((sheet, i) => {
        const cmdNo2 = pb.PuriContentListReq.CommandNo.COMMAND_NO
        const message2 = pb.PuriContentListReq.create({
          id: sheet.id
        })
        const encoded2 = pb.PuriContentListReq.encode(message2).finish()
        // 10枚ずつ取得
        if(i >= oldValue*10 && i < newValue*10){
          requests.push(this.post(cmdNo2, encoded2).catch(() => {
            this.$_error('Error', { title: 'プリダウンロード', statusCode: 420 })
          }))
        }
      })
      const decodes = await Promise.all(requests)

      decodes.forEach((decoded, i) => {
        const logoImg = this.logoList.find(item => item.name === this.splittedAllSheets[newValue-1][i].arcadeName).arcadeLogoImg
        this.sheets.push({
          id:  this.splittedAllSheets[newValue-1][i].id,
          arcadeName: this.splittedAllSheets[newValue-1][i].arcadeName,
          createDate: this.splittedAllSheets[newValue-1][i].createDate,
          limitDate: this.splittedAllSheets[newValue-1][i].limitDate,
          puriList: decoded.puriList,
          arcadeLogoImg: logoImg
        })
        // 全てpushしたら次へ
        if(i === decodes.length-1) this.splitSheetLists()
      })
    },
  },
  mounted() {
    this.checkMemberShip()
  },
  watch: {
    hasTappedSheet(v) {
      if (!v) {
        this.tappedSheet = null
      }
    },
    moreCount(newValue, oldValue){
      this.getPuriContents(newValue, oldValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.description {
  margin: 0 30px;
  padding-top: 30px;
  font-size: 12px;
  color: #373737;
}
section { padding-top: 30px; }
.dialog {
  position: relative;
  padding: 40px 0;
  background: white;
  color: #373737;
  border-radius: 8px;
  max-height: 70vh;
  font-size: 12px;
  &Text {
    padding: 0 15px;
    line-height: 1.8;
  }
  .NormalBtn { margin: 20px 15px 0; }
  .closeBtn {
    position: absolute;
    top: 20px;
    right: 15px;
    width: 16px;
    height: 12px;
    background-image:
      linear-gradient(35deg, transparent 45%, #5F96C9 48%, #5F96C9 52%, transparent 55%),
      linear-gradient(145deg, transparent 45%, #5F96C9 48%, #5F96C9 52%, transparent 55%);
  }
}
</style>
